var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('acgn-statistic-detail-nor',{attrs:{"comicId":_vm.comicId,"isShowTarget":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }